import React from 'react';
import Icon from '../../../components/AppIcon';

const WhyChooseUs = () => {
  const reasons = [
    {
      id: 1,
      icon: "Award",
      iconColor: "var(--color-primary)",
      bgColor: "bg-primary/10",
      title: "Dealer & Ahass Resmi Honda",
      description: "Terdaftar resmi sebagai dealer & Ahass Honda dengan sertifikasi lengkap dan jaminan keaslian produk"
    },
    {
      id: 2,
      icon: "Shield",
      iconColor: "var(--color-success)",
      bgColor: "bg-success/10",
      title: "Garansi Resmi",
      description: "Semua motor dilengkapi garansi resmi Honda dengan layanan purna jual terpercaya"
    },
    {
      id: 3,
      icon: "CreditCard",
      iconColor: "var(--color-warning)",
      bgColor: "bg-warning/10",
      title: "Kredit Mudah",
      description: "Proses kredit cepat dengan berbagai pilihan tenor dan bunga kompetitif dari bank terpercaya"
    },
    {
      id: 4,
      icon: "Wrench",
      iconColor: "var(--color-accent)",
      bgColor: "bg-accent/10",
      title: "Service Berkualitas",
      description: "Bengkel resmi dengan mekanik bersertifikat dan suku cadang original Honda"
    },
    {
      id: 5,
      icon: "Users",
      iconColor: "var(--color-primary)",
      bgColor: "bg-primary/10",
      title: "Tim Profesional",
      description: "Sales dan staff berpengalaman siap membantu Anda dengan pelayanan terbaik"
    },
    {
      id: 6,
      icon: "MapPin",
      iconColor: "var(--color-success)",
      bgColor: "bg-success/10",
      title: "Lokasi Strategis",
      description: "Berlokasi di Pamulang dengan akses mudah dan area parkir luas untuk kenyamanan Anda"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full mb-4">
            <Icon name="ThumbsUp" size={18} color="var(--color-primary)" />
            <span className="text-sm font-heading font-semibold text-primary">
              Keunggulan Kami
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Mengapa Memilih Honda Pamulang?
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Kami berkomitmen memberikan pengalaman terbaik dalam setiap aspek layanan untuk kepuasan Anda
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons?.map((reason) => (
            <div
              key={reason?.id}
              data-aos="fade-up"
              className="group bg-card rounded-xl p-6 shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 ${reason?.bgColor} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={reason?.icon} size={28} color={reason?.iconColor} strokeWidth={2} />
              </div>

              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground mb-2">
                {reason?.title}
              </h3>

              <p className="text-sm text-muted-foreground leading-relaxed">
                {reason?.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 bg-gradient-to-r from-card to-muted rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="space-y-6" data-aos="fade-right" >
              <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full">
                <Icon name="TrendingUp" size={18} color="var(--color-primary)" />
                <span className="text-sm font-heading font-semibold text-primary">
                  Pencapaian Kami
                </span>
              </div>

              <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground">
                Dipercaya oleh Ribuan Pelanggan di Tangerang Selatan
              </h3>

              <p className="text-base text-muted-foreground leading-relaxed">
                Sejak tahun 2010, Honda Pamulang telah melayani lebih dari 50.000 pelanggan dengan komitmen memberikan produk berkualitas dan layanan terbaik. Kepercayaan Anda adalah motivasi kami untuk terus berkembang.
              </p>

              <div className="grid grid-cols-2 gap-4" data-aos="fade-left">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Icon name="CheckCircle" size={20} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="text-sm font-heading font-semibold text-foreground">ISO 9001:2015</p>
                    <p className="text-xs text-muted-foreground">Sertifikasi Mutu</p>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
                    <Icon name="Award" size={20} color="var(--color-success)" />
                  </div>
                  <div>
                    <p className="text-sm font-heading font-semibold text-foreground">Best Dealer</p>
                    <p className="text-xs text-muted-foreground">Honda Award 2025</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4" data-aos="fade-left">
              <div className="bg-card rounded-xl p-6 text-center">
                <Icon name="Users" size={32} color="var(--color-primary)" className="mx-auto mb-3" />
                <div className="text-3xl font-heading font-bold text-primary mb-1">50K+</div>
                <div className="text-sm text-muted-foreground">Pelanggan Setia</div>
              </div>

              <div className="bg-card rounded-xl p-6 text-center">
                <Icon name="Star" size={32} color="var(--color-warning)" className="mx-auto mb-3" />
                <div className="text-3xl font-heading font-bold text-primary mb-1">4.9</div>
                <div className="text-sm text-muted-foreground">Rating Google</div>
              </div>

              <div className="bg-card rounded-xl p-6 text-center">
                <Icon name="Calendar" size={32} color="var(--color-success)" className="mx-auto mb-3" />
                <div className="text-3xl font-heading font-bold text-primary mb-1">15+</div>
                <div className="text-sm text-muted-foreground">Tahun Berpengalaman</div>
              </div>

              <div className="bg-card rounded-xl p-6 text-center">
                <Icon name="ThumbsUp" size={32} color="var(--color-accent)" className="mx-auto mb-3" />
                <div className="text-3xl font-heading font-bold text-primary mb-1">98%</div>
                <div className="text-sm text-muted-foreground">Kepuasan Pelanggan</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;